<template>
  <a-row type="flex" justify="center">
    <a-col :lg="lgCol" :md="14" :xs="24">
      <div class="no-items-card align-center">
        <div class="no-items-card-icon">
          <template v-if="$slots.icon">
            <slot name="icon"></slot>
          </template>
          <template v-else><a-icon type="tag" /></template>
        </div>

        <h3 class="no-items-card-title">
          <slot name="title"></slot>
        </h3>

        <template v-if="$slots.description">
          <p class="no-items-card-text">
            <slot name="description"></slot>
          </p>
        </template>

        <slot name="buttons"></slot>
      </div>
    </a-col>
  </a-row>
</template>

<script>
  export default {
    props: {
      lgCol: {
        type: Number,
        required: false,
        default: 12,
      }
    }
  };
</script>

<style>
  .no-items-card {
    background-color: #fff;
    box-shadow: 4px 4px 40px 0 rgba(0, 0, 0, 0.05);
    padding: 30px;
    color: #4D4F5C;
  }
  .no-items-card-icon {
    margin-bottom: 20px;
  }
  .no-items-card-icon i {
    font-size: 40px;
  }
  .no-items-card-title {
    font-size: 20px;
  }
  .no-items-card-text {
    font-size: 16px;
    margin-bottom: 20px;
  }
</style>
